import { call, put, all } from "redux-saga/effects";
import { loginAPI, autoLoginAPI } from "../api/LoginCall";
import { hasPermissionAPI } from "../api/HasPermissionCall";
import { loginFailure, loginSuccess } from "../actions/LoginActions";
import { moveToLoginPage, moveToMainPage } from "../actions/RouteActions";
import { reportError } from "../actions/ErrorActions";
import { endLoading, startLoading } from "../actions/LoadingActions";
import { logoutBegin, LogoutType } from "../actions/LogoutActions";


export function* loginSaga(action) {

  yield put(startLoading());
  const result = yield call(loginAPI, action);

  let hasPermission = false;
  const runPermissionCheck = result === 200;
  if (runPermissionCheck) {
    const returnedPermission = yield call(hasPermissionAPI, "ADMIN");
    hasPermission = returnedPermission["hasPermission"]
  }
  yield put(endLoading());

  try {
    if (result === 200 && hasPermission) {
      yield all([put(loginSuccess()), put(moveToMainPage())]);
    } else if (result === 401) {
      yield all([
        put(loginFailure()),
        put(reportError("Incorrect username or password")),
      ]);
    } else if (result === 423) {
      yield all([
        put(loginFailure()),
        put(
          reportError("Account has been locked for a 5 minutes period, too many failed login requests")
        ),
      ]);
    } else if (runPermissionCheck && !hasPermission) {
      yield all([
        put(loginFailure()),
        put(reportError("Unpermitted to use Judicator")),
        put(logoutBegin(LogoutType.SILENT))
      ])
    } else {
      yield all([
        put(loginFailure()),
        put(reportError("Unable to reach server")),
      ]);
    }
  } catch (ex) {
    yield all([
      put(loginFailure()),
      put(reportError("Unable to reach server")),
    ]);
  }
}

export function* autoLoginSaga() {
  try {
    const result = yield call(autoLoginAPI);

    let hasPermission = false;
    const runPermissionCheck = result === 200;
    if (runPermissionCheck) {
      const returnedPermission = yield call(hasPermissionAPI, "ADMIN");
      hasPermission = returnedPermission["hasPermission"]
    }

    if (result === 200 && hasPermission) {
      yield put(moveToMainPage());
    } else if(runPermissionCheck && !hasPermission) {
      yield all([
        put(logoutBegin(LogoutType.SILENT)),
        put(moveToLoginPage())
      ]);
    } else {
      yield put(moveToLoginPage());
    }
  } catch (ex) {
    yield put(moveToLoginPage());
  }
}
